module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAfUlEQVQ4T2NkIBMw4tL3//9/DpAcIyPjD2xq8GmsgmpsI1VjHVRj0yDSCA2IUgYGBhYkZ9lB2YeQxP4xMDDMZmRkfAYOnP///7MzMDAUMDAwMCMpcoKy9yGJ/WdgYJjPyMj4Al+oDsbAwRZP////JzsB8EETwCeSEgChtA8Afl82Dzn29cgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/button_primary_icon.png
// module id = K/72
// module chunks = 1